import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { logService } from '../services/logService';

const LogServiceInitializer: React.FC = () => {
    const { user } = useAuth();

    useEffect(() => {
        if (user?.id) {
            logService.init(user.id);
        }
    }, [user]);

    return null;
};

export default LogServiceInitializer;
